import { getAccessToken } from "./services";

/**
 * Čitanje claimova iz JWT-a.
 *
 * Ovo je SAMO za prikaz — da se administratoru klijenta ne otvori prazna ljuska umjesto jasne
 * poruke. Stvarna obrana je `[RequireSuperuser]` na API-ju; token se ovdje ne provjerava
 * kriptografski i na njega se ne smije oslanjati kao na sigurnosnu granicu.
 */
const readClaims = (): Record<string, unknown> | null => {
  const token = getAccessToken();

  if (!token) {
    return null;
  }

  const payload = token.split(".")[1];

  if (!payload) {
    return null;
  }

  try {
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(normalized));
  } catch {
    return null;
  }
};

/**
 * Korisničko ime iz tokena — u ovoj aplikaciji e-mail adresa.
 *
 * Služi da se na poruci o nedostatku pristupa vidi KOJIM se računom osoba prijavila; bez toga
 * ne zna je li pogriješila račun ili joj pravo stvarno nedostaje.
 */
export const getSignedInUserName = (): string | null => {
  const claims = readClaims();

  if (!claims) {
    return null;
  }

  const name =
    claims["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] ??
    claims["unique_name"] ??
    claims["name"];

  return typeof name === "string" ? name : null;
};

/** Je li prijavljeni korisnik naše osoblje. */
export const isSuperuser = (): boolean => {
  const claims = readClaims();

  if (!claims) {
    return false;
  }

  return claims["is_superuser"] === "true" || claims["is_superuser"] === true;
};
